(function () {
    function initMobileNavContentHydration() {
        if (window.__mobileNavContentHydrateInit) return;
        window.__mobileNavContentHydrateInit = true;

        function hydrateSingleImage(el) {
            if (el.querySelector('img')) return;
            var encoded = el.getAttribute('data-mobile-nav-src-secure');
            if (!encoded) return;
            var decodedSrc = atob(encoded);
            var img = document.createElement('img');
            img.className = 'mobile-nav-content__image';
            img.alt = el.getAttribute('data-mobile-nav-alt') || '';
            img.loading = 'lazy';
            img.src = decodedSrc;
            var srcset = el.getAttribute('data-mobile-nav-srcset');
            if (srcset) img.srcset = srcset;
            var sizes = el.getAttribute('data-mobile-nav-sizes');
            if (sizes) img.sizes = sizes;
            el.appendChild(img);
        }

        function hydrateDrawerImages(drawer) {
            drawer.querySelectorAll('[data-mobile-nav-src-secure]').forEach(hydrateSingleImage);
        }

        function removeDrawerImages(drawer) {
            drawer.querySelectorAll('[data-mobile-nav-src-secure] img').forEach(function (img) {
                img.remove();
            });
        }

        function syncDrawerImages(drawer) {
            if (drawer.getAttribute('expanded') === 'true') {
                hydrateDrawerImages(drawer);
            } else {
                removeDrawerImages(drawer);
            }
        }

        document.querySelectorAll('.mobile-nav-item__drawer').forEach(function (drawer) {
            if (!drawer.querySelector('[data-mobile-nav-src-secure]')) return;

            var sync = syncDrawerImages.bind(null, drawer);
            var mo = new MutationObserver(sync);
            mo.observe(drawer, { attributes: true, attributeFilter: ['expanded'] });
            sync();
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initMobileNavContentHydration);
    } else {
        initMobileNavContentHydration();
    }
})();